import { claimsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CLAIMS_ACTION_TYPE = createNamedActions('claims', {
  GET_CLAIMS: 'GET_CLAIMS',
  GET_CLAIMS_ROLE_BY_ROLE_ID: 'GET_CLAIMS_ROLE_BY_ROLE_ID',
});

export const getClaimsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await claimsApi.getClaims(params);

  return dispatch({
    type: CLAIMS_ACTION_TYPE.GET_CLAIMS,
    payload: data,
  });
});

export const getClaimsRoleByRoleIdAction = catchAsyncActionError(({ roleId }) => async dispatch => {
  const { data } = await claimsApi.getClaimsByRole({ roleId });

  return dispatch({
    type: CLAIMS_ACTION_TYPE.GET_CLAIMS_ROLE_BY_ROLE_ID,
    payload: { data, roleId },
  });
});
